// 导入Three.js库
import * as THREE from "../../libs/three.js/build/three.module.js";
// 导入常量定义和枚举
import { ClipTask, ClipMethod, CameraMode, LengthUnits, ElevationGradientRepeat } from "../defines.js";
// 导入渲染器
import { Renderer } from "../PotreeRenderer.js";
import { PotreeRenderer } from "./PotreeRenderer.js";
import { EDLRenderer } from "./EDLRenderer.js";
import { HQSplatRenderer } from "./HQSplatRenderer.js";
// 导入场景
import { Scene } from "./Scene.js";
// 导入工具类
import { ClippingTool } from "../utils/ClippingTool.js";
import { TransformationTool } from "../utils/TransformationTool.js";
import { Utils } from "../utils.js";
import { MapView } from "./map.js";
import { ProfileWindow, ProfileWindowController } from "./profile.js";
import { BoxVolume } from "../utils/Volume.js";
import { Features } from "../Features.js";
import { Message } from "../utils/Message.js";
import { Sidebar } from "./sidebar.js";

// 导入各种工具
import { AnnotationTool } from "../utils/AnnotationTool.js";
import { MeasuringTool } from "../utils/MeasuringTool.js";
import { ProfileTool } from "../utils/ProfileTool.js";
import { VolumeTool } from "../utils/VolumeTool.js";

// 导入导航和控制器
import { InputHandler } from "../navigation/InputHandler.js";
import { NavigationCube } from "./NavigationCube.js";
import { Compass } from "../utils/Compass.js";
import { OrbitControls } from "../navigation/OrbitControls.js";
import { FirstPersonControls } from "../navigation/FirstPersonControls.js";
import { EarthControls } from "../navigation/EarthControls.js";
import { DeviceOrientationControls } from "../navigation/DeviceOrientationControls.js";
import { VRControls } from "../navigation/VRControls.js";
import { EventDispatcher } from "../EventDispatcher.js";
import { ClassificationScheme } from "../materials/ClassificationScheme.js";
import { VRButton } from '../../libs/three.js/extra/VRButton.js';

// 导入JSON5解析库
import JSON5 from "../../libs/json5-2.1.3/json5.mjs";


// Viewer类 - Potree的主视图控制器，继承自EventDispatcher
export class Viewer extends EventDispatcher {

	/**
	 * 创建一个新的Viewer实例
	 * @param {HTMLElement} domElement - 用于渲染的DOM元素
	 * @param {Object} args - 配置参数
	 */
	constructor(domElement, args = {}) {
		super();

		this.renderArea = domElement;
		this.guiLoaded = false;
		this.guiLoadTasks = [];

		this.onVrListeners = [];

		// 消息系统初始化
		this.messages = [];
		this.elMessages = $(`
		<div id="message_listing" 
			style="position: absolute; z-index: 1000; left: 10px; bottom: 10px">
		</div>`);
		$(domElement).append(this.elMessages);

		try {

			{ // 生成缺失的DOM层次结构
				if ($(domElement).find('#potree_map').length === 0) {
					let potreeMap = $(`
					<div id="potree_map" class="mapBox" style="position: absolute; left: 50px; top: 50px; width: 400px; height: 400px; display: none">
						<div id="potree_map_header" style="position: absolute; width: 100%; height: 25px; top: 0px; background-color: rgba(0,0,0,0.5); z-index: 1000; border-top-left-radius: 3px; border-top-right-radius: 3px;">
						</div>
						<div id="potree_map_content" class="map" style="position: absolute; z-index: 100; top: 25px; width: 100%; height: calc(100% - 25px); border: 2px solid rgba(0,0,0,0.5); box-sizing: border-box;"></div>
					</div>
				`);
					$(domElement).append(potreeMap);
				}

				// 添加描述容器
				if ($(domElement).find('#potree_description').length === 0) {
					let potreeDescription = $(`<div id="potree_description" class="potree_info_text"></div>`);
					$(domElement).append(potreeDescription);
				}

				// 添加注释容器
				if ($(domElement).find('#potree_annotations').length === 0) {
					let potreeAnnotationContainer = $(`
					<div id="potree_annotation_container" 
						style="position: absolute; z-index: 100000; width: 100%; height: 100%; pointer-events: none;"></div>`);
					$(domElement).append(potreeAnnotationContainer);
				}

				// 添加快速按钮容器
				if ($(domElement).find('#potree_quick_buttons').length === 0) {
					let potreeMap = $(`
					<div id="potree_quick_buttons" class="quick_buttons_container" style="">
					</div>
				`);

					// {
					// 	let imgMenuToggle = document.createElement('img');
					// 	imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
					// 	imgMenuToggle.onclick = this.toggleSidebar;
					// 	// imgMenuToggle.classList.add('potree_menu_toggle');

					// 	potreeMap.append(imgMenuToggle);
					// }

					// {
					// 	let imgMenuToggle = document.createElement('img');
					// 	imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
					// 	imgMenuToggle.onclick = this.toggleSidebar;
					// 	// imgMenuToggle.classList.add('potree_menu_toggle');

					// 	potreeMap.append(imgMenuToggle);
					// }

					// {
					// 	let imgMenuToggle = document.createElement('img');
					// 	imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
					// 	imgMenuToggle.onclick = this.toggleSidebar;
					// 	// imgMenuToggle.classList.add('potree_menu_toggle');

					// 	potreeMap.append(imgMenuToggle);
					// }



					$(domElement).append(potreeMap);
				}
			}

			// 点云加载完成后的回调函数
			this.pointCloudLoadedCallback = args.onPointCloudLoaded || function () { };

			// if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
			//	defaultSettings.navigation = "Orbit";
			// }

			// 初始化各种属性
			this.server = null;

			this.fov = 60;
			this.isFlipYZ = false;
			this.useDEMCollisions = false;
			this.generateDEM = false;
			this.minNodeSize = 30;
			this.edlStrength = 1.0;
			this.edlRadius = 1.4;
			this.edlOpacity = 1.0;
			this.useEDL = false;
			this.description = "";

			// 分类方案设置为默认
			this.classifications = ClassificationScheme.DEFAULT;

			this.moveSpeed = 10;

			// 长度单位设置
			this.lengthUnit = LengthUnits.METER;
			this.lengthUnitDisplay = LengthUnits.METER;

			// 显示选项
			this.showBoundingBox = false;
			this.showAnnotations = true;
			this.freeze = false;
			this.clipTask = ClipTask.HIGHLIGHT;
			this.clipMethod = ClipMethod.INSIDE_ANY;

			this.elevationGradientRepeat = ElevationGradientRepeat.CLAMP;

			// 过滤器设置
			this.filterReturnNumberRange = [0, 7];
			this.filterNumberOfReturnsRange = [0, 7];
			this.filterGPSTimeRange = [-Infinity, Infinity];
			this.filterPointSourceIDRange = [0, 65535];

			// 渲染器
			this.potreeRenderer = null;
			this.edlRenderer = null;
			this.renderer = null;
			this.pRenderer = null;

			// 场景相关
			this.scene = null;
			this.sceneVR = null;
			this.overlay = null;
			this.overlayCamera = null;

			// 控制和工具
			this.inputHandler = null;
			this.controls = null;

			this.clippingTool = null;
			this.transformationTool = null;
			this.navigationCube = null;
			this.compass = null;

			this.skybox = null;
			this.clock = new THREE.Clock();
			this.background = null;

			// 初始化Three.js
			this.initThree();

			// 初始化拖放功能
			if (args.noDragAndDrop) {

			} else {
				this.initDragAndDrop();
			}

			// 如果可用，初始化性能统计
			if (typeof Stats !== "undefined") {
				this.stats = new Stats();
				this.stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
				document.body.appendChild(this.stats.dom);
			}

			{
				// 添加WebGL上下文丢失事件处理
				let canvas = this.renderer.domElement;
				canvas.addEventListener("webglcontextlost", (e) => {
					console.log(e);
					this.postMessage("WebGL context lost. \u2639");

					let gl = this.renderer.getContext();
					let error = gl.getError();
					console.log(error);
				}, false);
			}

			{
				// 创建叠加层场景和相机
				this.overlay = new THREE.Scene();
				this.overlayCamera = new THREE.OrthographicCamera(
					0, 1,
					1, 0,
					-1000, 1000
				);
			}

			// 初始化渲染器
			this.pRenderer = new Renderer(this.renderer);

			{
				// 初始化阴影测试相机
				let near = 2.5;
				let far = 10.0;
				let fov = 90;

				this.shadowTestCam = new THREE.PerspectiveCamera(90, 1, near, far);
				this.shadowTestCam.position.set(3.50, -2.80, 8.561);
				this.shadowTestCam.lookAt(new THREE.Vector3(0, 0, 4.87));
			}


			// 创建场景
			let scene = new Scene(this.renderer);

			{ // 创建VR场景
				this.sceneVR = new THREE.Scene();

				// let texture = new THREE.TextureLoader().load(`${Potree.resourcePath}/images/vr_controller_help.jpg`);

				// let plane = new THREE.PlaneBufferGeometry(1, 1, 1, 1);
				// let infoMaterial = new THREE.MeshBasicMaterial({map: texture});
				// let infoNode = new THREE.Mesh(plane, infoMaterial);
				// infoNode.position.set(-0.5, 1, 0);
				// infoNode.scale.set(0.4, 0.3, 1);
				// infoNode.lookAt(0, 1, 0)
				// this.sceneVR.add(infoNode);

				// window.infoNode = infoNode;
			}

			this.setScene(scene);

			{
				// 初始化输入处理和各种工具
				this.inputHandler = new InputHandler(this);
				this.inputHandler.setScene(this.scene);

				this.clippingTool = new ClippingTool(this);
				this.transformationTool = new TransformationTool(this);
				this.navigationCube = new NavigationCube(this);
				this.navigationCube.visible = false;

				this.compass = new Compass(this);

				this.createControls();

				this.clippingTool.setScene(this.scene);

				// 当添加点云时的事件处理
				let onPointcloudAdded = (e) => {
					if (this.scene.pointclouds.length === 1) {
						let speed = e.pointcloud.boundingBox.getSize(new THREE.Vector3()).length();
						speed = speed / 5;
						this.setMoveSpeed(speed);
					}
				};

				// 当体积被移除时的事件处理
				let onVolumeRemoved = (e) => {
					this.inputHandler.deselect(e.volume);
				};

				// 当场景改变时的事件处理
				this.addEventListener('scene_changed', (e) => {
					this.inputHandler.setScene(e.scene);
					this.clippingTool.setScene(this.scene);

					if (!e.scene.hasEventListener("pointcloud_added", onPointcloudAdded)) {
						e.scene.addEventListener("pointcloud_added", onPointcloudAdded);
					}

					if (!e.scene.hasEventListener("volume_removed", onPointcloudAdded)) {
						e.scene.addEventListener("volume_removed", onVolumeRemoved);
					}

				});

				this.scene.addEventListener("volume_removed", onVolumeRemoved);
				this.scene.addEventListener('pointcloud_added', onPointcloudAdded);
			}

			{ // 设置默认值
				this.setFOV(60);
				this.setEDLEnabled(false);
				this.setEDLRadius(1.4);
				this.setEDLStrength(0.4);
				this.setEDLOpacity(1.0);
				this.setClipTask(ClipTask.HIGHLIGHT);
				this.setClipMethod(ClipMethod.INSIDE_ANY);
				this.setPointBudget(1 * 1000 * 1000);
				this.setShowBoundingBox(false);
				this.setFreeze(false);
				this.setControls(this.orbitControls);
				this.setBackground('gradient');

				this.scaleFactor = 1;

				// 从URL加载设置
				this.loadSettingsFromURL();
			}

			// 开始渲染循环
			//if(args.useDefaultRenderLoop === undefined || args.useDefaultRenderLoop === true){
			//requestAnimationFrame(this.loop.bind(this));
			//}

			this.renderer.setAnimationLoop(this.loop.bind(this));

			this.loadGUI = this.loadGUI.bind(this);

			// 初始化各种工具
			this.annotationTool = new AnnotationTool(this);
			this.measuringTool = new MeasuringTool(this);
			this.profileTool = new ProfileTool(this);
			this.volumeTool = new VolumeTool(this);

		} catch (e) {
			this.onCrash(e);
		}
	}

	/**
	 * 处理崩溃异常，显示错误页面
	 * @param {Error} error - 捕获的错误对象
	 */
	onCrash(error) {

		$(this.renderArea).empty();

		if ($(this.renderArea).find('#potree_failpage').length === 0) {
			let elFailPage = $(`
			<div id="#potree_failpage" class="potree_failpage"> 
				
				<h1>Potree Encountered An Error </h1>

				<p>
				This may happen if your browser or graphics card is not supported.
				<br>
				We recommend to use 
				<a href="https://www.google.com/chrome/browser" target="_blank" style="color:initial">Chrome</a>
				or 
				<a href="https://www.mozilla.org/" target="_blank">Firefox</a>.
				</p>

				<p>
				Please also visit <a href="http://webglreport.com/" target="_blank">webglreport.com</a> and 
				check whether your system supports WebGL.
				</p>
				<p>
				If you are already using one of the recommended browsers and WebGL is enabled, 
				consider filing an issue report at <a href="https://github.com/potree/potree/issues" target="_blank">github</a>,<br>
				including your operating system, graphics card, browser and browser version, as well as the 
				error message below.<br>
				Please do not report errors on unsupported browsers.
				</p>

				<pre id="potree_error_console" style="width: 100%; height: 100%"></pre>
				
			</div>`);

			let elErrorMessage = elFailPage.find('#potree_error_console');
			elErrorMessage.html(error.stack);

			$(this.renderArea).append(elFailPage);
		}

		throw error;
	}

	// ------------------------------------------------------------------------------------
	// Viewer API
	// ------------------------------------------------------------------------------------

	/**
	 * 设置场景
	 * @param {Scene} scene - 要设置的场景
	 */
	setScene(scene) {
		if (scene === this.scene) {
			return;
		}

		let oldScene = this.scene;
		this.scene = scene;

		this.dispatchEvent({
			type: 'scene_changed',
			oldScene: oldScene,
			scene: scene
		});

		{ // Annotations
			$('.annotation').detach();

			// for(let annotation of this.scene.annotations){
			//	this.renderArea.appendChild(annotation.domElement[0]);
			// }

			this.scene.annotations.traverse(annotation => {
				this.renderArea.appendChild(annotation.domElement[0]);
			});

			if (!this.onAnnotationAdded) {
				this.onAnnotationAdded = e => {
					// console.log("annotation added: " + e.annotation.title);

					e.annotation.traverse(node => {

						$("#potree_annotation_container").append(node.domElement);
						//this.renderArea.appendChild(node.domElement[0]);
						node.scene = this.scene;
					});
				};
			}

			if (oldScene) {
				oldScene.annotations.removeEventListener('annotation_added', this.onAnnotationAdded);
			}
			this.scene.annotations.addEventListener('annotation_added', this.onAnnotationAdded);
		}
	};

	/**
	 * 设置控制器
	 * @param {Object} controls - 要设置的控制器
	 */
	setControls(controls) {
		if (controls !== this.controls) {
			if (this.controls) {
				this.controls.enabled = false;
				this.inputHandler.removeInputListener(this.controls);
			}

			this.controls = controls;
			this.controls.enabled = true;
			this.inputHandler.addInputListener(this.controls);
		}
	}

	/**
	 * 获取当前控制器
	 * @returns {Object} 当前活动的控制器
	 */
	getControls() {

		if (this.renderer.xr.isPresenting) {
			return this.vrControls;
		} else {
			return this.controls;
		}

	}

	/**
	 * 获取最小节点大小
	 * @returns {Number} 最小节点大小
	 */
	getMinNodeSize() {
		return this.minNodeSize;
	};

	/**
	 * 设置最小节点大小
	 * @param {Number} value - 最小节点大小值
	 */
	setMinNodeSize(value) {
		if (this.minNodeSize !== value) {
			this.minNodeSize = value;
			this.dispatchEvent({ 'type': 'minnodesize_changed', 'viewer': this });
		}
	};

	/**
	 * 获取背景设置
	 * @returns {String} 背景设置
	 */
	getBackground() {
		return this.background;
	}

	/**
	 * 设置背景类型
	 * @param {String} bg - 背景类型
	 */
	setBackground(bg) {
		if (this.background === bg) {
			return;
		}

		if (bg === "skybox") {
			this.skybox = Utils.loadSkybox(new URL(Potree.resourcePath + '/textures/skybox2/').href);
		}

		this.background = bg;
		this.dispatchEvent({ 'type': 'background_changed', 'viewer': this });
	}

	/**
	 * 设置描述文本
	 * @param {String} value - 描述内容
	 */
	setDescription(value) {
		this.description = value;

		$('#potree_description').html(value);
		//$('#potree_description').text(value);
	}

	/**
	 * 获取描述文本
	 * @returns {String} 当前描述
	 */
	getDescription() {
		return this.description;
	}

	/**
	 * 设置是否显示边界框
	 * @param {Boolean} value - 是否显示边界框
	 */
	setShowBoundingBox(value) {
		if (this.showBoundingBox !== value) {
			this.showBoundingBox = value;
			this.dispatchEvent({ 'type': 'show_boundingbox_changed', 'viewer': this });
		}
	};

	/**
	 * 获取是否显示边界框
	 * @returns {Boolean} 当前边界框显示状态
	 */
	getShowBoundingBox() {
		return this.showBoundingBox;
	};

	/**
	 * 设置移动速度
	 * @param {Number} value - 移动速度值
	 */
	setMoveSpeed(value) {
		if (this.moveSpeed !== value) {
			this.moveSpeed = value;
			this.dispatchEvent({ 'type': 'move_speed_changed', 'viewer': this, 'speed': value });
		}
	};

	/**
	 * 获取移动速度
	 * @returns {Number} 当前移动速度
	 */
	getMoveSpeed() {
		return this.moveSpeed;
	};

	/**
	 * 设置分类权重
	 * @param {Object} w - 分类权重对象
	 */
	setWeightClassification(w) {
		for (let i = 0; i < this.scene.pointclouds.length; i++) {
			this.scene.pointclouds[i].material.weightClassification = w;
			this.dispatchEvent({ 'type': 'attribute_weights_changed' + i, 'viewer': this });
		}
	};

	/**
	 * 设置冻结状态（是否停止更新）
	 * @param {Boolean} value - 冻结状态
	 */
	setFreeze(value) {
		value = Boolean(value);
		if (this.freeze !== value) {
			this.freeze = value;
			this.dispatchEvent({ 'type': 'freeze_changed', 'viewer': this });
		}
	};

	/**
	 * 获取冻结状态
	 * @returns {Boolean} 当前冻结状态
	 */
	getFreeze() {
		return this.freeze;
	};

	/**
	 * 获取裁剪任务
	 * @returns {ClipTask} 当前裁剪任务
	 */
	getClipTask() {
		return this.clipTask;
	}

	/**
	 * 获取裁剪方法
	 * @returns {ClipMethod} 当前裁剪方法
	 */
	getClipMethod() {
		return this.clipMethod;
	}

	/**
	 * 设置裁剪任务
	 * @param {ClipTask} value - 裁剪任务
	 */
	setClipTask(value) {
		if (this.clipTask !== value) {

			this.clipTask = value;

			this.dispatchEvent({
				type: "cliptask_changed",
				viewer: this
			});
		}
	}

	/**
	 * 设置裁剪方法
	 * @param {ClipMethod} value - 裁剪方法
	 */
	setClipMethod(value) {
		if (this.clipMethod !== value) {

			this.clipMethod = value;

			this.dispatchEvent({
				type: "clipmethod_changed",
				viewer: this
			});
		}
	}

	/**
	 * 设置高程梯度重复方式
	 * @param {ElevationGradientRepeat} value - 高程梯度重复方式
	 */
	setElevationGradientRepeat(value) {
		if (this.elevationGradientRepeat !== value) {

			this.elevationGradientRepeat = value;

			this.dispatchEvent({
				type: "elevation_gradient_repeat_changed",
				viewer: this
			});
		}
	}

	/**
	 * 设置点预算（每帧渲染的最大点数）
	 * @param {Number} value - 点预算数值
	 */
	setPointBudget(value) {
		if (Potree.pointBudget !== value) {
			Potree.pointBudget = parseInt(value);
			this.dispatchEvent({ 'type': 'point_budget_changed', 'viewer': this });
		}
	};

	/**
	 * 获取点预算
	 * @returns {Number} 当前点预算
	 */
	getPointBudget() {
		return Potree.pointBudget;
	};

	/**
	 * 设置是否显示注释
	 * @param {Boolean} value - 是否显示注释
	 */
	setShowAnnotations(value) {
		if (this.showAnnotations !== value) {
			this.showAnnotations = value;
			this.dispatchEvent({ 'type': 'show_annotations_changed', 'viewer': this });
		}
	}

	/**
	 * 获取是否显示注释
	 * @returns {Boolean} 当前注释显示状态
	 */
	getShowAnnotations() {
		return this.showAnnotations;
	}

	/**
	 * 设置是否启用DEM碰撞
	 * @param {Boolean} value - 是否启用DEM碰撞
	 */
	setDEMCollisionsEnabled(value) {
		if (this.useDEMCollisions !== value) {
			this.useDEMCollisions = value;
			this.dispatchEvent({ 'type': 'use_demcollisions_changed', 'viewer': this });
		};
	};

	/**
	 * 获取是否启用DEM碰撞
	 * @returns {Boolean} 当前DEM碰撞状态
	 */
	getDEMCollisionsEnabled() {
		return this.useDEMCollisions;
	};

	/**
	 * 设置是否启用EDL
	 * @param {Boolean} value - 是否启用EDL
	 */
	setEDLEnabled(value) {
		value = Boolean(value) && Features.SHADER_EDL.isSupported();

		if (this.useEDL !== value) {
			this.useEDL = value;
			this.dispatchEvent({ 'type': 'use_edl_changed', 'viewer': this });
		}
	};

	/**
	 * 获取是否启用EDL
	 * @returns {Boolean} 当前EDL状态
	 */
	getEDLEnabled() {
		return this.useEDL;
	};

	/**
	 * 设置EDL半径
	 * @param {Number} value - EDL半径值
	 */
	setEDLRadius(value) {
		if (this.edlRadius !== value) {
			this.edlRadius = value;
			this.dispatchEvent({ 'type': 'edl_radius_changed', 'viewer': this });
		}
	};

	/**
	 * 获取EDL半径
	 * @returns {Number} 当前EDL半径
	 */
	getEDLRadius() {
		return this.edlRadius;
	};

	/**
	 * 设置EDL强度
	 * @param {Number} value - EDL强度值
	 */
	setEDLStrength(value) {
		if (this.edlStrength !== value) {
			this.edlStrength = value;
			this.dispatchEvent({ 'type': 'edl_strength_changed', 'viewer': this });
		}
	};

	/**
	 * 获取EDL强度
	 * @returns {Number} 当前EDL强度
	 */
	getEDLStrength() {
		return this.edlStrength;
	};

	/**
	 * 设置EDL透明度
	 * @param {Number} value - EDL透明度值
	 */
	setEDLOpacity(value) {
		if (this.edlOpacity !== value) {
			this.edlOpacity = value;
			this.dispatchEvent({ 'type': 'edl_opacity_changed', 'viewer': this });
		}
	};

	/**
	 * 获取EDL透明度
	 * @returns {Number} 当前EDL透明度
	 */
	getEDLOpacity() {
		return this.edlOpacity;
	};

	/**
	 * 设置视野角度
	 * @param {Number} value - 视野角度值
	 */
	setFOV(value) {
		if (this.fov !== value) {
			this.fov = value;
			this.dispatchEvent({ 'type': 'fov_changed', 'viewer': this });
		}
	};

	/**
	 * 获取视野角度
	 * @returns {Number} 当前视野角度
	 */
	getFOV() {
		return this.fov;
	};

	/**
	 * 禁用注释
	 */
	disableAnnotations() {
		this.scene.annotations.traverse(annotation => {
			annotation.domElement.css('pointer-events', 'none');

			// return annotation.visible;
		});
	};

	/**
	 * 启用注释
	 */
	enableAnnotations() {
		this.scene.annotations.traverse(annotation => {
			annotation.domElement.css('pointer-events', 'auto');

			// return annotation.visible;
		});
	}

	/**
	 * 设置分类方案
	 * @param {ClassificationScheme} classifications - 分类方案对象
	 */
	setClassifications(classifications) {
		this.classifications = classifications;

		this.dispatchEvent({ 'type': 'classifications_changed', 'viewer': this });
	}

	/**
	 * 设置分类可见性
	 * @param {String} key - 分类键
	 * @param {Boolean} value - 分类可见性
	 */
	setClassificationVisibility(key, value) {
		if (!this.classifications[key]) {
			this.classifications[key] = { visible: value, name: 'no name' };
			this.dispatchEvent({ 'type': 'classification_visibility_changed', 'viewer': this });
		} else if (this.classifications[key].visible !== value) {
			this.classifications[key].visible = value;
			this.dispatchEvent({ 'type': 'classification_visibility_changed', 'viewer': this });
		}
	}

	/**
	 * 切换所有分类的可见性
	 */
	toggleAllClassificationsVisibility() {

		let numVisible = 0;
		let numItems = 0;
		for (const key of Object.keys(this.classifications)) {
			if (this.classifications[key].visible) {
				numVisible++;
			}
			numItems++;
		}

		let visible = true;
		if (numVisible === numItems) {
			visible = false;
		}

		let somethingChanged = false;

		for (const key of Object.keys(this.classifications)) {
			if (this.classifications[key].visible !== visible) {
				this.classifications[key].visible = visible;
				somethingChanged = true;
			}
		}

		if (somethingChanged) {
			this.dispatchEvent({ 'type': 'classification_visibility_changed', 'viewer': this });
		}
	}

	/**
	 * 设置返回编号范围
	 * @param {Number} from - 返回编号范围起始值
	 * @param {Number} to - 返回编号范围结束值
	 */
	setFilterReturnNumberRange(from, to) {
		this.filterReturnNumberRange = [from, to];
		this.dispatchEvent({ 'type': 'filter_return_number_range_changed', 'viewer': this });
	}

	/**
	 * 设置返回编号范围
	 * @param {Number} from - 返回编号范围起始值
	 * @param {Number} to - 返回编号范围结束值
	 */
	setFilterNumberOfReturnsRange(from, to) {
		this.filterNumberOfReturnsRange = [from, to];
		this.dispatchEvent({ 'type': 'filter_number_of_returns_range_changed', 'viewer': this });
	}

	/**
	 * 设置GPS时间范围
	 * @param {Number} from - GPS时间范围起始值
	 * @param {Number} to - GPS时间范围结束值
	 */
	setFilterGPSTimeRange(from, to) {
		this.filterGPSTimeRange = [from, to];
		this.dispatchEvent({ 'type': 'filter_gps_time_range_changed', 'viewer': this });
	}

	/**
	 * 设置点源ID范围
	 * @param {Number} from - 点源ID范围起始值
	 * @param {Number} to - 点源ID范围结束值
	 */
	setFilterPointSourceIDRange(from, to) {
		this.filterPointSourceIDRange = [from, to]
		this.dispatchEvent({ 'type': 'filter_point_source_id_range_changed', 'viewer': this });
	}

	/**
	 * 设置长度单位
	 * @param {String} value - 长度单位
	 */
	setLengthUnit(value) {
		switch (value) {
			case 'm':
				this.lengthUnit = LengthUnits.METER;
				this.lengthUnitDisplay = LengthUnits.METER;
				break;
			case 'ft':
				this.lengthUnit = LengthUnits.FEET;
				this.lengthUnitDisplay = LengthUnits.FEET;
				break;
			case 'in':
				this.lengthUnit = LengthUnits.INCH;
				this.lengthUnitDisplay = LengthUnits.INCH;
				break;
		}

		this.dispatchEvent({ 'type': 'length_unit_changed', 'viewer': this, value: value });
	};

	/**
	 * 设置长度单位和显示单位
	 * @param {String} lengthUnitValue - 长度单位值
	 * @param {String} lengthUnitDisplayValue - 显示单位值
	 */
	setLengthUnitAndDisplayUnit(lengthUnitValue, lengthUnitDisplayValue) {
		switch (lengthUnitValue) {
			case 'm':
				this.lengthUnit = LengthUnits.METER;
				break;
			case 'ft':
				this.lengthUnit = LengthUnits.FEET;
				break;
			case 'in':
				this.lengthUnit = LengthUnits.INCH;
				break;
		}

		switch (lengthUnitDisplayValue) {
			case 'm':
				this.lengthUnitDisplay = LengthUnits.METER;
				break;
			case 'ft':
				this.lengthUnitDisplay = LengthUnits.FEET;
				break;
			case 'in':
				this.lengthUnitDisplay = LengthUnits.INCH;
				break;
		}

		this.dispatchEvent({ 'type': 'length_unit_changed', 'viewer': this, value: lengthUnitValue });
	};

	/**
	 * 缩放到指定节点
	 * @param {Object} node - 要缩放的节点
	 * @param {Number} factor - 缩放因子
	 * @param {Number} animationDuration - 动画持续时间
	 */
	zoomTo(node, factor, animationDuration = 0) {
		let view = this.scene.view;

		let camera = this.scene.cameraP.clone();
		camera.rotation.copy(this.scene.cameraP.rotation);
		camera.rotation.order = "ZXY";
		camera.rotation.x = Math.PI / 2 + view.pitch;
		camera.rotation.z = view.yaw;
		camera.updateMatrix();
		camera.updateMatrixWorld();
		camera.zoomTo(node, factor);

		let bs;
		if (node.boundingSphere) {
			bs = node.boundingSphere;
		} else if (node.geometry && node.geometry.boundingSphere) {
			bs = node.geometry.boundingSphere;
		} else {
			bs = node.boundingBox.getBoundingSphere(new THREE.Sphere());
		}
		bs = bs.clone().applyMatrix4(node.matrixWorld);

		let startPosition = view.position.clone();
		let endPosition = camera.position.clone();
		let startTarget = view.getPivot();
		let endTarget = bs.center;
		let startRadius = view.radius;
		let endRadius = endPosition.distanceTo(endTarget);

		let easing = TWEEN.Easing.Quartic.Out;

		{ // animate camera position
			let pos = startPosition.clone();
			let tween = new TWEEN.Tween(pos).to(endPosition, animationDuration);
			tween.easing(easing);

			tween.onUpdate(() => {
				view.position.copy(pos);
			});

			tween.start();
		}

		{ // animate camera target
			let target = startTarget.clone();
			let tween = new TWEEN.Tween(target).to(endTarget, animationDuration);
			tween.easing(easing);
			tween.onUpdate(() => {
				view.lookAt(target);
			});
			tween.onComplete(() => {
				view.lookAt(target);
				this.dispatchEvent({ type: 'focusing_finished', target: this });
			});

			this.dispatchEvent({ type: 'focusing_started', target: this });
			tween.start();
		}
	};

	/**
	 * 移动到指定GPS时间附近的区域
	 * @param {Number} time - GPS时间
	 */
	moveToGpsTimeVicinity(time) {
		const result = Potree.Utils.findClosestGpsTime(time, viewer);

		const box = result.node.pointcloud.deepestNodeAt(result.position).getBoundingBox();
		const diameter = box.min.distanceTo(box.max);

		const camera = this.scene.getActiveCamera();
		const offset = camera.getWorldDirection(new THREE.Vector3()).multiplyScalar(diameter);
		const newCamPos = result.position.clone().sub(offset);

		this.scene.view.position.copy(newCamPos);
		this.scene.view.lookAt(result.position);
	}

	/**
	 * 显示关于信息
	 */
	showAbout() {
		$(function () {
			$('#about-panel').dialog();
		});
	};

	/**
	 * 获取边界框
	 * @param {Array} pointclouds - 点云数组
	 * @returns {Box3} 边界框
	 */
	getBoundingBox(pointclouds) {
		return this.scene.getBoundingBox(pointclouds);
	};

	/**
	 * 获取GPS时间范围
	 * @returns {Array} GPS时间范围
	 */
	getGpsTimeExtent() {
		const range = [Infinity, -Infinity];

		for (const pointcloud of this.scene.pointclouds) {
			const attributes = pointcloud.pcoGeometry.pointAttributes.attributes;
			const aGpsTime = attributes.find(a => a.name === "gps-time");

			if (aGpsTime) {
				range[0] = Math.min(range[0], aGpsTime.range[0]);
				range[1] = Math.max(range[1], aGpsTime.range[1]);
			}
		}

		return range;
	}

	/**
	 * 适应屏幕大小
	 * @param {Number} factor - 缩放因子
	 * @param {Number} animationDuration - 动画持续时间
	 */
	fitToScreen(factor = 1, animationDuration = 0) {
		let box = this.getBoundingBox(this.scene.pointclouds);

		let node = new THREE.Object3D();
		node.boundingBox = box;

		this.zoomTo(node, factor, animationDuration);
		this.controls.stop();
	};

	/**
	 * 切换导航立方体可见性
	 */
	toggleNavigationCube() {
		this.navigationCube.visible = !this.navigationCube.visible;
	}

	/**
	 * 设置视图
	 * @param {String} view - 视图名称
	 */
	setView(view) {
		if (!view) return;

		switch (view) {
			case "F":
				this.setFrontView();
				break;
			case "B":
				this.setBackView();
				break;
			case "L":
				this.setLeftView();
				break;
			case "R":
				this.setRightView();
				break;
			case "U":
				this.setTopView();
				break;
			case "D":
				this.setBottomView();
				break;
		}
	}

	/**
	 * 设置顶部视图
	 */
	setTopView() {
		this.scene.view.yaw = 0;
		this.scene.view.pitch = -Math.PI / 2;

		this.fitToScreen();
	};

	/**
	 * 设置底部视图
	 */
	setBottomView() {
		this.scene.view.yaw = -Math.PI;
		this.scene.view.pitch = Math.PI / 2;

		this.fitToScreen();
	};

	/**
	 * 设置前视图
	 */
	setFrontView() {
		this.scene.view.yaw = 0;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	/**
	 * 设置后视图
	 */
	setBackView() {
		this.scene.view.yaw = Math.PI;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	/**
	 * 设置左视图
	 */
	setLeftView() {
		this.scene.view.yaw = -Math.PI / 2;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	/**
	 * 设置右视图
	 */
	setRightView() {
		this.scene.view.yaw = Math.PI / 2;
		this.scene.view.pitch = 0;

		this.fitToScreen();
	};

	/**
	 * 翻转YZ轴
	 */
	flipYZ() {
		this.isFlipYZ = !this.isFlipYZ;

		// TODO flipyz
		console.log('TODO');
	}

	/**
	 * 设置相机模式
	 * @param {CameraMode} mode - 相机模式
	 */
	setCameraMode(mode) {
		this.scene.cameraMode = mode;

		for (let pointcloud of this.scene.pointclouds) {
			pointcloud.material.useOrthographicCamera = mode == CameraMode.ORTHOGRAPHIC;
		}
	}

	/**
	 * 获取投影
	 * @returns {Matrix4} 投影矩阵
	 */
	getProjection() {
		const pointcloud = this.scene.pointclouds[0];

		if (pointcloud) {
			return pointcloud.projection;
		} else {
			return null;
		}
	}

	/**
	 * 异步加载项目
	 * @param {String} url - 项目URL
	 */
	async loadProject(url) {

		const response = await fetch(url);

		const text = await response.text();
		const json = JSON5.parse(text);
		// const json = JSON.parse(text);

		if (json.type === "Potree") {
			Potree.loadProject(viewer, json);
		}

		//Potree.loadProject(this, url);
	}

	/**
	 * 保存项目
	 * @returns {String} 项目JSON字符串
	 */
	saveProject() {
		return Potree.saveProject(this);
	}

	/**
	 * 从URL加载设置
	 */
	loadSettingsFromURL() {
		if (Utils.getParameterByName("pointSize")) {
			this.setPointSize(parseFloat(Utils.getParameterByName("pointSize")));
		}

		if (Utils.getParameterByName("FOV")) {
			this.setFOV(parseFloat(Utils.getParameterByName("FOV")));
		}

		if (Utils.getParameterByName("opacity")) {
			this.setOpacity(parseFloat(Utils.getParameterByName("opacity")));
		}

		if (Utils.getParameterByName("edlEnabled")) {
			let enabled = Utils.getParameterByName("edlEnabled") === "true";
			this.setEDLEnabled(enabled);
		}

		if (Utils.getParameterByName('edlRadius')) {
			this.setEDLRadius(parseFloat(Utils.getParameterByName('edlRadius')));
		}

		if (Utils.getParameterByName('edlStrength')) {
			this.setEDLStrength(parseFloat(Utils.getParameterByName('edlStrength')));
		}

		if (Utils.getParameterByName('pointBudget')) {
			this.setPointBudget(parseFloat(Utils.getParameterByName('pointBudget')));
		}

		if (Utils.getParameterByName('showBoundingBox')) {
			let enabled = Utils.getParameterByName('showBoundingBox') === 'true';
			if (enabled) {
				this.setShowBoundingBox(true);
			} else {
				this.setShowBoundingBox(false);
			}
		}

		if (Utils.getParameterByName('material')) {
			let material = Utils.getParameterByName('material');
			this.setMaterial(material);
		}

		if (Utils.getParameterByName('pointSizing')) {
			let sizing = Utils.getParameterByName('pointSizing');
			this.setPointSizing(sizing);
		}

		if (Utils.getParameterByName('quality')) {
			let quality = Utils.getParameterByName('quality');
			this.setQuality(quality);
		}

		if (Utils.getParameterByName('position')) {
			let value = Utils.getParameterByName('position');
			value = value.replace('[', '').replace(']', '');
			let tokens = value.split(';');
			let x = parseFloat(tokens[0]);
			let y = parseFloat(tokens[1]);
			let z = parseFloat(tokens[2]);

			this.scene.view.position.set(x, y, z);
		}

		if (Utils.getParameterByName('target')) {
			let value = Utils.getParameterByName('target');
			value = value.replace('[', '').replace(']', '');
			let tokens = value.split(';');
			let x = parseFloat(tokens[0]);
			let y = parseFloat(tokens[1]);
			let z = parseFloat(tokens[2]);

			this.scene.view.lookAt(new THREE.Vector3(x, y, z));
		}

		if (Utils.getParameterByName('background')) {
			let value = Utils.getParameterByName('background');
			this.setBackground(value);
		}

		// if(Utils.getParameterByName("elevationRange")){
		//	let value = Utils.getParameterByName("elevationRange");
		//	value = value.replace("[", "").replace("]", "");
		//	let tokens = value.split(";");
		//	let x = parseFloat(tokens[0]);
		//	let y = parseFloat(tokens[1]);
		//
		//	this.setElevationRange(x, y);
		//	//this.scene.view.target.set(x, y, z);
		// }
	};

	// ------------------------------------------------------------------------------------
	// Viewer Internals
	// ------------------------------------------------------------------------------------

	/**
	 * 创建控制器
	 */
	createControls() {
		{ // create FIRST PERSON CONTROLS
			this.fpControls = new FirstPersonControls(this);
			this.fpControls.enabled = false;
			this.fpControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.fpControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		// { // create GEO CONTROLS
		//	this.geoControls = new GeoControls(this.scene.camera, this.renderer.domElement);
		//	this.geoControls.enabled = false;
		//	this.geoControls.addEventListener("start", this.disableAnnotations.bind(this));
		//	this.geoControls.addEventListener("end", this.enableAnnotations.bind(this));
		//	this.geoControls.addEventListener("move_speed_changed", (event) => {
		//		this.setMoveSpeed(this.geoControls.moveSpeed);
		//	});
		// }

		{ // create ORBIT CONTROLS
			this.orbitControls = new OrbitControls(this);
			this.orbitControls.enabled = false;
			this.orbitControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.orbitControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		{ // create EARTH CONTROLS
			this.earthControls = new EarthControls(this);
			this.earthControls.enabled = false;
			this.earthControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.earthControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		{ // create DEVICE ORIENTATION CONTROLS
			this.deviceControls = new DeviceOrientationControls(this);
			this.deviceControls.enabled = false;
			this.deviceControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.deviceControls.addEventListener('end', this.enableAnnotations.bind(this));
		}

		{ // create VR CONTROLS
			this.vrControls = new VRControls(this);
			this.vrControls.enabled = false;
			this.vrControls.addEventListener('start', this.disableAnnotations.bind(this));
			this.vrControls.addEventListener('end', this.enableAnnotations.bind(this));
		}


	};

	/**
	 * 切换侧边栏可见性
	 */
	toggleSidebar() {
		let renderArea = $('#potree_render_area');
		let isVisible = renderArea.css('left') !== '0px';

		if (isVisible) {
			renderArea.css('left', '0px');
		} else {
			renderArea.css('left', '300px');
		}
	};

	/**
	 * 切换地图可见性
	 */
	toggleMap() {
		// let map = $('#potree_map');
		// map.toggle(100);

		if (this.mapView) {
			this.mapView.toggle();
		}
	};

	/**
	 * 当GUI加载完成时回调
	 * @param {Function} callback - 回调函数
	 */
	onGUILoaded(callback) {
		if (this.guiLoaded) {
			callback();
		} else {
			this.guiLoadTasks.push(callback);
		}
	}

	/**
	 * 返回一个Promise对象，表示GUI加载完成
	 * @returns {Promise} 
	 */
	promiseGuiLoaded() {
		return new Promise(resolve => {

			if (this.guiLoaded) {
				resolve();
			} else {
				this.guiLoadTasks.push(resolve);
			}

		});
	}

	/**
	 * 加载GUI
	 * @param {Function} callback - 回调函数
	 */
	loadGUI(callback) {

		if (callback) {
			this.onGUILoaded(callback);
		}

		let viewer = this;
		let sidebarContainer = $('#potree_sidebar_container');
		sidebarContainer.load(new URL(Potree.scriptPath + '/sidebar.html').href, () => {
			sidebarContainer.css('width', '300px');
			sidebarContainer.css('height', '100%');

			let imgMenuToggle = document.createElement('img');
			imgMenuToggle.src = new URL(Potree.resourcePath + '/icons/menu_button.svg').href;
			imgMenuToggle.onclick = this.toggleSidebar;
			imgMenuToggle.classList.add('potree_menu_toggle');

			let imgMapToggle = document.createElement('img');
			imgMapToggle.src = new URL(Potree.resourcePath + '/icons/map_icon.png').href;
			imgMapToggle.style.display = 'none';
			imgMapToggle.onclick = e => { this.toggleMap(); };
			imgMapToggle.id = 'potree_map_toggle';



			let elButtons = $("#potree_quick_buttons").get(0);

			elButtons.append(imgMenuToggle);
			elButtons.append(imgMapToggle);


			VRButton.createButton(this.renderer).then(vrButton => {

				if (vrButton == null) {
					console.log("VR not supported or active.");

					return;
				}

				this.renderer.xr.enabled = true;

				let element = vrButton.element;

				element.style.position = "";
				element.style.bottom = "";
				element.style.left = "";
				element.style.margin = "4px";
				element.style.fontSize = "100%";
				element.style.width = "2.5em";
				element.style.height = "2.5em";
				element.style.padding = "0";
				element.style.textShadow = "black 2px 2px 2px";
				element.style.display = "block";

				elButtons.append(element);

				vrButton.onStart(() => {
					this.dispatchEvent({ type: "vr_start" });
				});

				vrButton.onEnd(() => {
					this.dispatchEvent({ type: "vr_end" });
				});
			});

			this.mapView = new MapView(this);
			this.mapView.init();

			i18n.init({
				lng: 'en',
				resGetPath: Potree.resourcePath + '/lang/__lng__/__ns__.json',
				preload: ['en', 'fr', 'de', 'jp', 'se', 'es', 'zh', 'it', 'ca'],
				getAsync: true,
				debug: false
			}, function (t) {
				// Start translation once everything is loaded
				$('body').i18n();
			});

			$(() => {
				//initSidebar(this);
				let sidebar = new Sidebar(this);
				sidebar.init();

				this.sidebar = sidebar;

				//if (callback) {
				//	$(callback);
				//}

				let elProfile = $('<div>').load(new URL(Potree.scriptPath + '/profile.html').href, () => {
					$(document.body).append(elProfile.children());
					this.profileWindow = new ProfileWindow(this);
					this.profileWindowController = new ProfileWindowController(this);

					$('#profile_window').draggable({
						handle: $('#profile_titlebar'),
						containment: $(document.body)
					});
					$('#profile_window').resizable({
						containment: $(document.body),
						handles: 'n, e, s, w'
					});

					$(() => {
						this.guiLoaded = true;
						for (let task of this.guiLoadTasks) {
							task();
						}

					});
				});



			});


		});

		return this.promiseGuiLoaded();
	}

	/**
	 * 设置语言
	 * @param {String} lang - 语言代码
	 */
	setLanguage(lang) {
		i18n.setLng(lang);
		$('body').i18n();
	}

	/**
	 * 设置服务器
	 * @param {Object} server - 服务器对象
	 */
	setServer(server) {
		this.server = server;
	}

	/**
	 * 初始化拖放功能
	 */
	initDragAndDrop() {
		function allowDrag(e) {
			e.dataTransfer.dropEffect = 'copy';
			e.preventDefault();
		}

		let dropHandler = async (event) => {
			console.log(event);
			event.preventDefault();

			for (const item of event.dataTransfer.items) {
				console.log(item);

				if (item.kind !== "file") {
					continue;
				}

				const file = item.getAsFile();

				const isJson5 = file.name.toLowerCase().endsWith(".json5");
				const isGeoPackage = file.name.toLowerCase().endsWith(".gpkg");

				if (isJson5) {
					try {

						const text = await file.text();
						const json = JSON5.parse(text);

						if (json.type === "Potree") {
							Potree.loadProject(viewer, json);
						}

						if (json.type === "Classification") {
							Potree.loadClassification(viewer, json);
							this.dispatchEvent({
								type: 'classfication_loaded',
								data: json
							});
						}

					} catch (e) {
						console.error("failed to parse the dropped file as JSON");
						console.error(e);
					}
				} else if (isGeoPackage) {
					const hasPointcloud = viewer.scene.pointclouds.length > 0;

					if (!hasPointcloud) {
						let msg = "At least one point cloud is needed that specifies the ";
						msg += "coordinate reference system before loading vector data.";
						console.error(msg);
					} else {

						proj4.defs("WGS84", "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs");
						proj4.defs("pointcloud", this.getProjection());
						let transform = proj4("WGS84", "pointcloud");

						const buffer = await file.arrayBuffer();

						const params = {
							transform: transform,
							source: file.name,
						};

						const geo = await Potree.GeoPackageLoader.loadBuffer(buffer, params);
						viewer.scene.addGeopackage(geo);
					}
				}

			}
		};


		$("body")[0].addEventListener("dragenter", allowDrag);
		$("body")[0].addEventListener("dragover", allowDrag);
		$("body")[0].addEventListener("drop", dropHandler);
	}

	/**
	 * 初始化Three.js
	 */
	initThree() {

		console.log(`initializing three.js ${THREE.REVISION}`);

		let width = this.renderArea.clientWidth;
		let height = this.renderArea.clientHeight;

		let contextAttributes = {
			alpha: true,
			depth: true,
			stencil: false,
			antialias: false,
			//premultipliedAlpha: _premultipliedAlpha,
			preserveDrawingBuffer: true,
			powerPreference: "high-performance",
		};

		// let contextAttributes = {
		// 	alpha: false,
		// 	preserveDrawingBuffer: true,
		// };

		// let contextAttributes = {
		// 	alpha: false,
		// 	preserveDrawingBuffer: true,
		// };

		let canvas = document.createElement("canvas");

		let context = canvas.getContext('webgl', contextAttributes);

		this.renderer = new THREE.WebGLRenderer({
			alpha: true,
			premultipliedAlpha: false,
			canvas: canvas,
			context: context
		});
		this.renderer.sortObjects = false;
		this.renderer.setSize(width, height);
		this.renderer.autoClear = false;
		this.renderArea.appendChild(this.renderer.domElement);
		this.renderer.domElement.tabIndex = '2222';
		this.renderer.domElement.style.position = 'absolute';
		this.renderer.domElement.addEventListener('mousedown', () => {
			this.renderer.domElement.focus();
		});
		//this.renderer.domElement.focus();

		// WebGL扩展初始化部分
		// 注意：如果扩展出错，可在启用前将字符串传入this.renderer.extensions.get(x)
		// 为插值着色器启用frag_depth扩展（如果可用）
		let gl = this.renderer.getContext();
		gl.getExtension('EXT_frag_depth');           // 启用片段深度扩展，允许在片段着色器中修改深度值
		gl.getExtension('WEBGL_depth_texture');      // 启用深度纹理扩展，允许使用深度纹理
		gl.getExtension('WEBGL_color_buffer_float'); // 显式启用浮点颜色缓冲区，提高WebGL 2中的兼容性，EXT_color_buffer_float是WebGL 2中的正确名称

		// 检查顶点数组对象(VAO)扩展并提供兼容性实现
		if (gl.createVertexArray == null) {
			let extVAO = gl.getExtension('OES_vertex_array_object');

			if (!extVAO) {
				throw new Error("OES_vertex_array_object extension not supported");
			}

			// 绑定VAO扩展方法到WebGL上下文
			gl.createVertexArray = extVAO.createVertexArrayOES.bind(extVAO);
			gl.bindVertexArray = extVAO.bindVertexArrayOES.bind(extVAO);
		}

	}

	/**
	 * 更新注释
	 * 管理场景中注释的可见性和屏幕位置
	 */
	updateAnnotations() {

		// 初始化可见注释集合（如果未创建）
		if (!this.visibleAnnotations) {
			this.visibleAnnotations = new Set();
		}

		// 更新注释边界并确保相机矩阵是最新的
		this.scene.annotations.updateBounds();
		this.scene.cameraP.updateMatrixWorld();
		this.scene.cameraO.updateMatrixWorld();

		let distances = [];

		// 获取渲染区域尺寸
		let renderAreaSize = this.renderer.getSize(new THREE.Vector2());

		let viewer = this;

		// 存储当前可见的注释
		let visibleNow = [];
		this.scene.annotations.traverse(annotation => {

			// 跳过根注释
			if (annotation === this.scene.annotations) {
				return true;
			}

			// 跳过不可见的注释
			if (!annotation.visible) {
				return false;
			}

			// 设置场景引用
			annotation.scene = this.scene;

			let element = annotation.domElement;

			// 计算注释在世界空间中的位置（包括偏移）
			let position = annotation.position.clone();
			position.add(annotation.offset);
			if (!position) {
				position = annotation.boundingBox.getCenter(new THREE.Vector3());
			}

			// 计算相机到注释的距离和注释的边界球半径
			let distance = viewer.scene.cameraP.position.distanceTo(position);
			let radius = annotation.boundingBox.getBoundingSphere(new THREE.Sphere()).radius;

			let screenPos = new THREE.Vector3();
			let screenSize = 0;

			{
				// 计算屏幕坐标
				screenPos.copy(position).project(this.scene.getActiveCamera());
				screenPos.x = renderAreaSize.x * (screenPos.x + 1) / 2;
				screenPos.y = renderAreaSize.y * (1 - (screenPos.y + 1) / 2);


				// 计算屏幕尺寸
				if (viewer.scene.cameraMode == CameraMode.PERSPECTIVE) {
					// 在透视相机模式下计算
					let fov = Math.PI * viewer.scene.cameraP.fov / 180;
					let slope = Math.tan(fov / 2.0);
					let projFactor = 0.5 * renderAreaSize.y / (slope * distance);
					screenSize = radius * projFactor;
				} else {
					// 在正交相机模式下计算
					screenSize = Utils.projectedRadiusOrtho(radius, viewer.scene.cameraO.projectionMatrix, renderAreaSize.x, renderAreaSize.y);
				}
			}

			// 设置注释DOM元素的屏幕位置
			element.css("left", screenPos.x + "px");
			element.css("top", screenPos.y + "px");
			//element.css("display", "block");

			// 根据距离计算z-index，使远处的注释位于近处注释的后面
			let zIndex = 10000000 - distance * (10000000 / this.scene.cameraP.far);
			if (annotation.descriptionVisible) {
				zIndex += 10000000; // 描述可见时提高z-index
			}
			element.css("z-index", parseInt(zIndex));

			// 处理有子注释的情况
			if (annotation.children.length > 0) {
				// 当屏幕尺寸大于折叠阈值或相机位于边界盒内时展开注释
				let expand = screenSize > annotation.collapseThreshold || annotation.boundingBox.containsPoint(this.scene.getActiveCamera().position);
				annotation.expand = expand;

				if (!expand) {
					// 如果不展开且在视锥体内，则添加到可见列表
					let inFrustum = (screenPos.z >= -1 && screenPos.z <= 1);
					if (inFrustum) {
						visibleNow.push(annotation);
					}
				}

				return expand;
			} else {
				// 如果注释在视锥体内，添加到可见列表
				let inFrustum = (screenPos.z >= -1 && screenPos.z <= 1);
				if (inFrustum) {
					visibleNow.push(annotation);
				}
			}

		});

		// 计算不再可见的注释
		let notVisibleAnymore = new Set(this.visibleAnnotations);
		for (let annotation of visibleNow) {
			annotation.display = true;

			notVisibleAnymore.delete(annotation);
		}
		this.visibleAnnotations = visibleNow;

		// 隐藏不再可见的注释
		for (let annotation of notVisibleAnymore) {
			annotation.display = false;
		}

	}

	/**
	 * 更新默认材质属性
	 * @param {Object} pointcloud - 点云对象
	 * 
	 * 问题说明：
	 * 1. 强度、源ID等的[最小值,最大值]是在点云加载过程中逐步计算的
	 * 2. 点云材质在加载数据之前不知道应该使用的范围
	 * 3. 用户可以在运行时修改范围，但即使没有GUI，也应该应用合理的默认范围
	 * 4. 显示范围不应该突然变化，即使实际范围随时间变化
	 *    例如：根节点的强度范围为[1, 478]。后代节点之一将范围扩大到[0, 2047]。
	 *    我们不应该自动切换到新范围，因为这会导致亮度的突然和剧烈变化。
	 *    我们应该调整侧边栏滑块的最小/最大值。
	 */
	updateMaterialDefaults(pointcloud) {
		const material = pointcloud.material;

		// 获取点云的强度属性
		const attIntensity = pointcloud.getAttribute("intensity");

		// 如果存在强度属性且材质的强度范围尚未设置（默认为Infinity）
		// 则使用点云的强度范围值初始化材质的强度范围
		if (attIntensity != null && material.intensityRange[0] === Infinity) {
			material.intensityRange = [...attIntensity.range];
		}

		// 较旧的、被注释掉的实现方式
		// const attIntensity = pointcloud.getAttribute("intensity");
		// if(attIntensity && material.intensityRange[0] === Infinity){
		// 	material.intensityRange = [...attIntensity.range];
		// }

		// 为所有属性设置范围的替代方法
		// let attributes = pointcloud.getAttributes();
		// for(let attribute of attributes.attributes){
		// 	if(attribute.range){
		// 		let range = [...attribute.range];
		// 		material.computedRange.set(attribute.name, range);
		// 		//material.setRange(attribute.name, range);
		// 	}
		// }
	}

	/**
	 * 更新场景和点云状态
	 * @param {Number} delta - 时间间隔（秒）
	 * @param {Number} timestamp - 当前时间戳
	 */
	update(delta, timestamp) {
		// 性能计时开始标记
		if (Potree.measureTimings) performance.mark("update-start");

		// 触发更新开始事件
		this.dispatchEvent({
			type: 'update_start',
			delta: delta,
			timestamp: timestamp
		});

		// 获取当前场景、相机和可见点云
		const scene = this.scene;
		const camera = scene.getActiveCamera();
		const visiblePointClouds = this.scene.pointclouds.filter(pc => pc.visible);

		// 设置全局点加载限制为点预算的两倍
		Potree.pointLoadLimit = Potree.pointBudget * 2;

		// 更新方向光位置，使其始终位于相机位置并指向相机前方
		const lTarget = camera.position.clone().add(camera.getWorldDirection(new THREE.Vector3()).multiplyScalar(1000));
		this.scene.directionalLight.position.copy(camera.position);
		this.scene.directionalLight.lookAt(lTarget);

		// 更新所有可见点云的属性和材质
		for (let pointcloud of visiblePointClouds) {
			// 设置显示选项
			pointcloud.showBoundingBox = this.showBoundingBox;
			pointcloud.generateDEM = this.generateDEM;
			pointcloud.minimumNodePixelSize = this.minNodeSize;

			// 获取点云材质
			let material = pointcloud.material;

			// 设置过滤器范围
			material.uniforms.uFilterReturnNumberRange.value = this.filterReturnNumberRange;
			material.uniforms.uFilterNumberOfReturnsRange.value = this.filterNumberOfReturnsRange;
			material.uniforms.uFilterGPSTimeClipRange.value = this.filterGPSTimeRange;
			material.uniforms.uFilterPointSourceIDClipRange.value = this.filterPointSourceIDRange;

			// 设置分类方案并重新计算
			material.classification = this.classifications;
			material.recomputeClassification();

			// 更新材质默认值
			this.updateMaterialDefaults(pointcloud);
		}

		// 处理边界盒显示
		{
			if (this.showBoundingBox) {
				// 查找或创建边界盒根节点
				let bbRoot = this.scene.scene.getObjectByName("potree_bounding_box_root");
				if (!bbRoot) {
					let node = new THREE.Object3D();
					node.name = "potree_bounding_box_root";
					this.scene.scene.add(node);
					bbRoot = node;
				}

				// 收集所有可见节点的边界盒
				let visibleBoxes = [];
				for (let pointcloud of this.scene.pointclouds) {
					for (let node of pointcloud.visibleNodes.filter(vn => vn.boundingBoxNode !== undefined)) {
						let box = node.boundingBoxNode;
						visibleBoxes.push(box);
					}
				}

				// 更新边界盒根节点的子节点
				bbRoot.children = visibleBoxes;
			}
		}

		// 如果不在冻结状态，更新点云
		if (!this.freeze) {
			let result = Potree.updatePointClouds(scene.pointclouds, camera, this.renderer);

			// DEBUG - 仅显示与鼠标相交的节点
			//if(false){ 
			//	let renderer = viewer.renderer;
			//	let mouse = viewer.inputHandler.mouse;
			//
			//	let nmouse = {
			//		x: (mouse.x / renderer.domElement.clientWidth) * 2 - 1,
			//		y: -(mouse.y / renderer.domElement.clientHeight) * 2 + 1
			//	};
			//
			//	let pickParams = {};
			//
			//	//if(params.pickClipped){
			//	//	pickParams.pickClipped = params.pickClipped;
			//	//}
			//
			//	pickParams.x = mouse.x;
			//	pickParams.y = renderer.domElement.clientHeight - mouse.y;
			//
			//	let raycaster = new THREE.Raycaster();
			//	raycaster.setFromCamera(nmouse, camera);
			//	let ray = raycaster.ray;
			//
			//	for(let pointcloud of scene.pointclouds){
			//		let nodes = pointcloud.nodesOnRay(pointcloud.visibleNodes, ray);
			//		pointcloud.visibleNodes = nodes;
			//
			//	}
			//}

			// 查找最近的图像（用于相机近平面调整）
			const tStart = performance.now();
			const campos = camera.position;
			let closestImage = Infinity;
			for (const images of this.scene.orientedImages) {
				for (const image of images.images) {
					const distance = image.mesh.position.distanceTo(campos);

					closestImage = Math.min(closestImage, distance);
				}
			}
			const tEnd = performance.now();

			// 根据点云最低间距调整相机近远平面
			if (result.lowestSpacing !== Infinity) {
				let near = result.lowestSpacing * 10.0;
				let far = -this.getBoundingBox().applyMatrix4(camera.matrixWorldInverse).min.z;

				far = Math.max(far * 1.5, 10000);
				near = Math.min(100.0, Math.max(0.01, near));
				near = Math.min(near, closestImage); // 确保近平面不会裁剪最近的图像
				far = Math.max(far, near + 10000); // 确保远平面至少比近平面远10000单位

				if (near === Infinity) {
					near = 0.1;
				}

				camera.near = near;
				camera.far = far;
			} else {
				// 不改变近平面和远平面
			}

			// 在正交模式下调整近平面
			if (this.scene.cameraMode == CameraMode.ORTHOGRAPHIC) {
				camera.near = -camera.far;
			}
		}

		// 设置透视相机的视场角
		this.scene.cameraP.fov = this.fov;

		// 更新控制器
		let controls = this.getControls();
		if (controls === this.deviceControls) {
			this.controls.setScene(scene);
			this.controls.update(delta);

			this.scene.cameraP.position.copy(scene.view.position);
			this.scene.cameraO.position.copy(scene.view.position);
		} else if (controls !== null) {
			controls.setScene(scene);
			controls.update(delta);

			if (typeof debugDisabled === "undefined") {
				this.scene.cameraP.position.copy(scene.view.position);
				this.scene.cameraP.rotation.order = "ZXY";
				this.scene.cameraP.rotation.x = Math.PI / 2 + this.scene.view.pitch;
				this.scene.cameraP.rotation.z = this.scene.view.yaw;
			}

			this.scene.cameraO.position.copy(scene.view.position);
			this.scene.cameraO.rotation.order = "ZXY";
			this.scene.cameraO.rotation.x = Math.PI / 2 + this.scene.view.pitch;
			this.scene.cameraO.rotation.z = this.scene.view.yaw;
		}

		// 更新相机矩阵
		camera.updateMatrix();
		camera.updateMatrixWorld();
		camera.matrixWorldInverse.copy(camera.matrixWorld).invert();

		// 处理相机变化事件
		{
			if (this._previousCamera === undefined) {
				this._previousCamera = this.scene.getActiveCamera().clone();
				this._previousCamera.rotation.copy(this.scene.getActiveCamera().rotation);
			}

			// 如果相机矩阵或投影矩阵发生变化，触发相机变化事件
			if (!this._previousCamera.matrixWorld.equals(camera.matrixWorld)) {
				this.dispatchEvent({
					type: "camera_changed",
					previous: this._previousCamera,
					camera: camera
				});
			} else if (!this._previousCamera.projectionMatrix.equals(camera.projectionMatrix)) {
				this.dispatchEvent({
					type: "camera_changed",
					previous: this._previousCamera,
					camera: camera
				});
			}

			// 更新前一帧相机状态
			this._previousCamera = this.scene.getActiveCamera().clone();
			this._previousCamera.rotation.copy(this.scene.getActiveCamera().rotation);
		}

		// 更新裁剪盒
		{
			let boxes = [];

			// 收集启用裁剪的盒体积
			//boxes.push(...this.scene.volumes.filter(v => (v.clip)));
			boxes.push(...this.scene.volumes.filter(v => (v.clip && v instanceof BoxVolume)));

			// 收集所有剖面线段的盒子
			for (let profile of this.scene.profiles) {
				boxes.push(...profile.boxes);
			}

			// 排除退化的盒子（行列式为0）
			// 在获取逆矩阵前需要，参见 #815 / #816
			let degenerate = (box) => box.matrixWorld.determinant() !== 0;

			// 创建裁剪盒数组
			let clipBoxes = boxes.filter(degenerate).map(box => {
				box.updateMatrixWorld();

				let boxInverse = box.matrixWorld.clone().invert();
				let boxPosition = box.getWorldPosition(new THREE.Vector3());

				return { box: box, inverse: boxInverse, position: boxPosition };
			});

			// 获取已初始化的多边形裁剪体
			let clipPolygons = this.scene.polygonClipVolumes.filter(vol => vol.initialized);

			// 为所有可见点云设置裁剪体
			for (let pointcloud of visiblePointClouds) {
				pointcloud.material.setClipBoxes(clipBoxes);
				pointcloud.material.setClipPolygons(clipPolygons, this.clippingTool.maxPolygonVertices);
				pointcloud.material.clipTask = this.clipTask;
				pointcloud.material.clipMethod = this.clipMethod;
			}
		}

		// 更新所有点云的高程梯度重复方式
		{
			for (let pointcloud of visiblePointClouds) {
				pointcloud.material.elevationGradientRepeat = this.elevationGradientRepeat;
			}
		}

		// 更新导航立方体
		{
			this.navigationCube.update(camera.rotation);
		}

		// 更新注释
		this.updateAnnotations();

		// 更新地图视图
		if (this.mapView) {
			this.mapView.update(delta);
			if (this.mapView.sceneProjection) {
				$("#potree_map_toggle").css("display", "block");
			}
		}

		// 更新补间动画
		TWEEN.update(timestamp);

		// 触发更新完成事件
		this.dispatchEvent({
			type: 'update',
			delta: delta,
			timestamp: timestamp
		});

		// 性能计时结束
		if (Potree.measureTimings) {
			performance.mark("update-end");
			performance.measure("update", "update-start", "update-end");
		}
	}

	/**
	 * 获取渲染器
	 * @returns {Object} 渲染器对象
	 */
	getPRenderer() {
		if (this.useHQ) {
			if (!this.hqRenderer) {
				this.hqRenderer = new HQSplatRenderer(this);
			}
			this.hqRenderer.useEDL = this.useEDL;

			return this.hqRenderer;
		} else {
			if (this.useEDL && Features.SHADER_EDL.isSupported()) {
				if (!this.edlRenderer) {
					this.edlRenderer = new EDLRenderer(this);
				}

				return this.edlRenderer;
			} else {
				if (!this.potreeRenderer) {
					this.potreeRenderer = new PotreeRenderer(this);
				}

				return this.potreeRenderer;
			}
		}
	}

	/**
	 * 渲染VR场景
	 * 处理虚拟现实模式下的渲染，包括双眼立体渲染和空间定位
	 */
	renderVR() {

		let renderer = this.renderer;

		// 设置清屏颜色并清空缓冲区
		renderer.setClearColor(0x550000, 0);
		renderer.clear();

		// 获取XR相机
		let xr = renderer.xr;
		let dbg = new THREE.PerspectiveCamera();
		let xrCameras = xr.getCamera(dbg);

		// 检查是否有两个眼睛的相机（双眼立体渲染）
		if (xrCameras.cameras.length !== 2) {
			return;
		}

		// 通过VR控制器获取相机
		let makeCam = this.vrControls.getCamera.bind(this.vrControls);

		{ // 清空帧缓冲区并设置适当的背景颜色
			if (viewer.background === "skybox") {
				renderer.setClearColor(0xff0000, 1);
			} else if (viewer.background === "gradient") {
				renderer.setClearColor(0x112233, 1);
			} else if (viewer.background === "black") {
				renderer.setClearColor(0x000000, 1);
			} else if (viewer.background === "white") {
				renderer.setClearColor(0xFFFFFF, 1);
			} else {
				renderer.setClearColor(0x000000, 0);
			}

			renderer.clear();
		}

		// 渲染背景（如果设置了天空盒）
		if (this.background === "skybox") {
			let { skybox } = this;

			let cam = makeCam();
			skybox.camera.rotation.copy(cam.rotation);
			skybox.camera.fov = cam.fov;
			skybox.camera.aspect = cam.aspect;

			// 设置天空盒父对象的旋转
			let dbg = skybox.parent;
			dbg.rotation.x = Math.PI / 2;

			// 更新矩阵
			dbg.updateMatrix();
			dbg.updateMatrixWorld();

			skybox.camera.updateMatrix();
			skybox.camera.updateMatrixWorld();
			skybox.camera.updateProjectionMatrix();

			// 渲染天空盒
			renderer.render(skybox.scene, skybox.camera);
		} else if (this.background === "gradient") {
			// 梯度背景渲染（被注释掉了）
			// renderer.render(this.scene.sceneBG, this.scene.cameraBG);
		}

		// 更新XR会话的渲染状态，设置深度范围
		this.renderer.xr.getSession().updateRenderState({
			depthNear: 0.1,
			depthFar: 10000
		});

		let cam = null;
		let view = null;

		{ // 渲染主场景
			// 创建并设置相机
			cam = makeCam();
			cam.position.z -= 0.8 * cam.scale.x; // 调整相机Z轴位置
			cam.parent = null;
			cam.near = viewer.scene.getActiveCamera().near;
			cam.far = viewer.scene.getActiveCamera().far;
			cam.updateMatrix();
			cam.updateMatrixWorld();

			// 更新场景矩阵
			this.scene.scene.updateMatrix();
			this.scene.scene.updateMatrixWorld();
			this.scene.scene.matrixAutoUpdate = false;

			// 创建视图矩阵并应用到场景
			let camWorld = cam.matrixWorld.clone();
			view = camWorld.clone().invert();
			this.scene.scene.matrix.copy(view);
			this.scene.scene.matrixWorld.copy(view);

			// 重置相机矩阵
			cam.matrix.identity();
			cam.matrixWorld.identity();
			cam.matrixWorldInverse.identity();

			// 渲染场景
			renderer.render(this.scene.scene, cam);

			this.scene.scene.matrixWorld.identity();
		}

		// 为点云设置VR参数
		for (let pointcloud of this.scene.pointclouds) {
			let viewport = xrCameras.cameras[0].viewport;

			// 在VR模式下关闭EDL（眼部穹顶光照）
			pointcloud.material.useEDL = false;
			pointcloud.screenHeight = viewport.height;
			pointcloud.screenWidth = viewport.width;

			// 自动切换到抛物线形状以减少VR中的闪烁
			// 当点大小超过约2像素时
			// if(Features.SHADER_INTERPOLATION.isSupported()){
			// 	pointcloud.material.shape = Potree.PointShape.PARABOLOID;
			// }
		}

		// 为每个XR相机渲染点云
		for (let xrCamera of xrCameras.cameras) {
			// 设置视口
			let v = xrCamera.viewport;
			renderer.setViewport(v.x, v.y, v.width, v.height);

			// 估算VR的视场角(FOV)
			{
				let proj = xrCamera.projectionMatrix;
				let inv = proj.clone().invert();

				let p1 = new THREE.Vector4(0, 1, -1, 1).applyMatrix4(inv);
				let rad = p1.y
				let fov = 180 * (rad / Math.PI);

				xrCamera.fov = fov;
			}

			// 确保所有点云的EDL都关闭
			for (let pointcloud of this.scene.pointclouds) {
				const { material } = pointcloud;
				material.useEDL = false;
			}

			// 计算VR世界变换和视图变换
			let vrWorld = view.clone().invert();
			vrWorld.multiply(xrCamera.matrixWorld);
			let vrView = vrWorld.clone().invert();

			// 使用自定义视图矩阵渲染点云场景
			this.pRenderer.render(this.scene.scenePointCloud, xrCamera, null, {
				viewOverride: vrView,
			});
		}

		// 渲染VR特定场景（例如控制器模型等）
		{
			let cam = makeCam();
			cam.parent = null;

			renderer.render(this.sceneVR, cam);
		}

		// 重置渲染器状态
		renderer.resetState();
	}

	/**
	 * 渲染默认（非VR）视图
	 * 处理标准屏幕渲染，包括调整大小和投影
	 */
	renderDefault() {
		// 获取适当的点云渲染器
		let pRenderer = this.getPRenderer();

		{ // 调整大小和投影矩阵
			// 根据缩放因子计算渲染尺寸
			const width = this.scaleFactor * this.renderArea.clientWidth;
			const height = this.scaleFactor * this.renderArea.clientHeight;

			// 设置渲染器尺寸
			this.renderer.setSize(width, height);
			const pixelRatio = this.renderer.getPixelRatio();
			const aspect = width / height;

			const scene = this.scene;

			// 更新透视相机的宽高比和投影矩阵
			scene.cameraP.aspect = aspect;
			scene.cameraP.updateProjectionMatrix();

			// 更新正交相机的视锥体和投影矩阵
			let frustumScale = this.scene.view.radius;
			scene.cameraO.left = -frustumScale;
			scene.cameraO.right = frustumScale;
			scene.cameraO.top = frustumScale * 1 / aspect;
			scene.cameraO.bottom = -frustumScale * 1 / aspect;
			scene.cameraO.updateProjectionMatrix();

			// 更新屏幕空间相机的投影矩阵
			scene.cameraScreenSpace.top = 1 / aspect;
			scene.cameraScreenSpace.bottom = -1 / aspect;
			scene.cameraScreenSpace.updateProjectionMatrix();
		}

		// 清除渲染器缓冲区
		pRenderer.clear();

		// 渲染点云场景和叠加层
		pRenderer.render(this.renderer);
		this.renderer.render(this.overlay, this.overlayCamera);
	}

	/**
	 * 渲染
	 */
	render() {
		if (Potree.measureTimings) performance.mark("render-start");

		try {

			const vrActive = this.renderer.xr.isPresenting;

			if (vrActive) {
				this.renderVR();
			} else {
				this.renderDefault();
			}

		} catch (e) {
			this.onCrash(e);
		}

		if (Potree.measureTimings) {
			performance.mark("render-end");
			performance.measure("render", "render-start", "render-end");
		}
	}

	/**
	 * 解析性能数据
	 * @param {Number} timestamp - 时间戳
	 */
	resolveTimings(timestamp) {
		if (Potree.measureTimings) {
			if (!this.toggle) {
				this.toggle = timestamp;
			}
			let duration = timestamp - this.toggle;
			if (duration > 1000.0) {

				let measures = performance.getEntriesByType("measure");

				let names = new Set();
				for (let measure of measures) {
					names.add(measure.name);
				}

				let groups = new Map();
				for (let name of names) {
					groups.set(name, {
						measures: [],
						sum: 0,
						n: 0,
						min: Infinity,
						max: -Infinity
					});
				}

				for (let measure of measures) {
					let group = groups.get(measure.name);
					group.measures.push(measure);
					group.sum += measure.duration;
					group.n++;
					group.min = Math.min(group.min, measure.duration);
					group.max = Math.max(group.max, measure.duration);
				}

				let glQueries = Potree.resolveQueries(this.renderer.getContext());
				for (let [key, value] of glQueries) {

					let group = {
						measures: value.map(v => { return { duration: v } }),
						sum: value.reduce((a, i) => a + i, 0),
						n: value.length,
						min: Math.min(...value),
						max: Math.max(...value)
					};

					let groupname = `[tq] ${key}`;
					groups.set(groupname, group);
					names.add(groupname);
				}

				for (let [name, group] of groups) {
					group.mean = group.sum / group.n;
					group.measures.sort((a, b) => a.duration - b.duration);

					if (group.n === 1) {
						group.median = group.measures[0].duration;
					} else if (group.n > 1) {
						group.median = group.measures[parseInt(group.n / 2)].duration;
					}

				}

				let cn = Array.from(names).reduce((a, i) => Math.max(a, i.length), 0) + 5;
				let cmin = 10;
				let cmed = 10;
				let cmax = 10;
				let csam = 6;

				let message = ` ${"NAME".padEnd(cn)} |`
					+ ` ${"MIN".padStart(cmin)} |`
					+ ` ${"MEDIAN".padStart(cmed)} |`
					+ ` ${"MAX".padStart(cmax)} |`
					+ ` ${"SAMPLES".padStart(csam)} \n`;
				message += ` ${"-".repeat(message.length)}\n`;

				names = Array.from(names).sort();
				for (let name of names) {
					let group = groups.get(name);
					let min = group.min.toFixed(3);
					let median = group.median.toFixed(3);
					let max = group.max.toFixed(3);
					let n = group.n;

					message += ` ${name.padEnd(cn)} |`
						+ ` ${min.padStart(cmin)} |`
						+ ` ${median.padStart(cmed)} |`
						+ ` ${max.padStart(cmax)} |`
						+ ` ${n.toString().padStart(csam)}\n`;
				}
				message += `\n`;
				console.log(message);

				performance.clearMarks();
				performance.clearMeasures();
				this.toggle = timestamp;
			}
		}
	}

	/**
	 * 渲染循环
	 * @param {Number} timestamp - 时间戳
	 */
	loop(timestamp) {

		if (this.stats) {
			this.stats.begin();
		}

		if (Potree.measureTimings) {
			performance.mark("loop-start");
		}

		this.update(this.clock.getDelta(), timestamp);
		this.render();

		// let vrActive = viewer.renderer.xr.isPresenting;
		// if(vrActive){
		// 	this.update(this.clock.getDelta(), timestamp);
		// 	this.render();
		// }else{

		// 	this.update(this.clock.getDelta(), timestamp);
		// 	this.render();
		// }


		if (Potree.measureTimings) {
			performance.mark("loop-end");
			performance.measure("loop", "loop-start", "loop-end");
		}

		this.resolveTimings(timestamp);

		Potree.framenumber++;

		if (this.stats) {
			this.stats.end();
		}
	}

	/**
	 * 发布错误信息
	 * @param {String} content - 错误内容
	 * @param {Object} params - 参数对象
	 * @returns {Message} 错误信息对象
	 */
	postError(content, params = {}) {
		let message = this.postMessage(content, params);

		message.element.addClass("potree_message_error");

		return message;
	}

	/**
	 * 发布消息
	 * @param {String} content - 消息内容
	 * @param {Object} params - 参数对象
	 * @returns {Message} 消息对象
	 */
	postMessage(content, params = {}) {
		let message = new Message(content, params.id);

		let animationDuration = 100;

		message.element.css("display", "none");
		message.elClose.click(() => {
			this.hideMessage(message);
		});

		this.elMessages.prepend(message.element);

		message.element.slideToggle(animationDuration);

		this.messages.push(message);

		if (params.duration !== undefined) {
			let fadeDuration = 500;
			let slideOutDuration = 200;
			setTimeout(() => {
				message.element.animate({
					opacity: 0
				}, fadeDuration);
				message.element.slideToggle(slideOutDuration);
			}, params.duration)
		}

		return message;
	}

	// 隐藏
	hideMessage(message) {
		let animationDuration = 100;

		message.element.slideToggle(animationDuration);

		let index = this.messages.indexOf(message);
		if (index >= 0) {
			this.messages.splice(index, 1);
		}
	}

	// 通过id查找对象
	getMessage(id) {
		for (let message of this.messages) {
		console.log(message.id,2780);

			if (message.id === id) {
				return message;
			}
		}

		
		return null;
	}
	// 通过id隐藏消息
	hideMessageById(id) {
		console.log(id,2789);
		
		let message = this.getMessage(id);

		console.log(message,2793);

		if (message) {
			this.hideMessage(message);
		}
	}
};
